import { Link } from 'react-router-dom';

interface BrandMarkProps {
  inverse?: boolean;
  linked?: boolean;
}

function BrandContent({ inverse = false }: Pick<BrandMarkProps, 'inverse'>) {
  return (
    <>
      <span className="relative flex h-9 w-9 items-center justify-center" aria-hidden="true">
        <span className="absolute h-7 w-5 -translate-x-1 rotate-[-10deg] rounded-[5px] border border-cyan/80 bg-cyan/15" />
        <span className="absolute h-7 w-5 translate-x-1 rotate-[8deg] rounded-[5px] border border-amber/80 bg-amber/15" />
        <span className="relative h-2 w-2 rounded-full bg-cyan shadow-[0_0_14px_rgba(25,211,197,.9)]" />
      </span>
      <span className="leading-none">
        <span className={`block text-[15px] font-bold tracking-[-0.03em] ${inverse ? 'text-white' : 'text-ink'}`}>
          AICardSearch
        </span>
        <span className={`mt-1 block text-[9px] font-semibold uppercase tracking-[0.2em] ${inverse ? 'text-white/45' : 'text-secondary-light'}`}>
          Pokémon market intelligence
        </span>
      </span>
    </>
  );
}

export default function BrandMark({ inverse = false, linked = true }: BrandMarkProps) {
  const className = "inline-flex items-center gap-2.5";
  if (!linked) {
    return <div className={className}><BrandContent inverse={inverse} /></div>;
  }
  return (
    <Link to="/" className={className} aria-label="AICardSearch home">
      <BrandContent inverse={inverse} />
    </Link>
  );
}
